/* assets/forms-teaser-visibility.js */
(() => {
  if (window.__formsTeaserHider) return;
  window.__formsTeaserHider = true;

  // — CONFIG —
  const STRICT_IFRAME_ONLY = true;   // alleen iframes met Shopify(Cloud) + (marketing|forms)
  const USE_CORNER_HEURISTIC = false; // evt. true zetten als jouw teaser niet via Shopify src komt

  const STATE_CLASSES = ['cart-open', 'menu-open'];
  const HOST_SELECTOR = 'div[class^="appEmbedRootTeaser_"], div[class*=" appEmbedRootTeaser_"]';

  const isHidden = () =>
    STATE_CLASSES.some(c =>
      document.documentElement.classList.contains(c) ||
      document.body.classList.contains(c)
    );

  let targets = new Set();
  let raf = null;
  const schedule = fn => { if (raf) return; raf = requestAnimationFrame(() => { raf = null; fn(); }); };

  function findTargets() {
    const found = new Set();

    // 1) Hosts met shadowRoot waarin de teaser zit
    document.querySelectorAll('*').forEach(host => {
      if (!host.shadowRoot) return;
      const hit = host.shadowRoot.querySelector(
        '[class*="button_teaserContainer"],[data-shopify*="teaser"],[class*="teaser"]'
      );
      if (hit) found.add(host);
    });

    // 2) Fallback: directe DOM-hosts met gehashte class
    document.querySelectorAll(HOST_SELECTOR).forEach(el => found.add(el));

    // 3) Iframes die als teaser fungeren
    document.querySelectorAll('iframe').forEach(frame => {
      const src = frame.getAttribute('src') || '';
      const looksLikeForms = /(shopifycloud|cdn\.shopify).*?(extensions|app-embed|marketing|forms)/i.test(src);

      let inCorner = false;
      if (!STRICT_IFRAME_ONLY && USE_CORNER_HEURISTIC) {
        const cs = getComputedStyle(frame);
        if (cs.position === 'fixed') {
          const r = frame.getBoundingClientRect();
          inCorner = r.left <= 40 && (innerHeight - r.bottom) <= 40 && r.width <= 180 && r.height <= 180;
        }
      }

      if (looksLikeForms || inCorner) found.add(frame);
    });

    targets = found;
  }

  function apply() {
    const hide = isHidden();
    if (!targets.size) findTargets();
    targets.forEach(el => {
      el.style.setProperty('display', hide ? 'none' : '', 'important');
      el.style.setProperty('visibility', hide ? 'hidden' : '', 'important');
      el.style.setProperty('pointer-events', hide ? 'none' : '', 'important');
    });
  }

  function init() {
    apply();

    // Observe alleen class-wijzigingen (lichtgewicht)
    new MutationObserver(() => schedule(apply))
      .observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(() => schedule(apply))
      .observe(document.body, { attributes: true, attributeFilter: ['class'] });

    // Re-scan bij dynamische mounts
    new MutationObserver(() => schedule(() => { findTargets(); apply(); }))
      .observe(document.documentElement, { childList: true, subtree: true });

    window.addEventListener('resize', () => { findTargets(); apply(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
